import mixpanel from 'mixpanel-browser'

const MIX_PANEL_TOKEN = process.env.REACT_APP_MIX_PANEL
const MIXPANEL_ENABLED = Boolean(MIX_PANEL_TOKEN)

// Percentage (0-100) of SDK initializations that qualify for Session Replay
// capture. Defaults to 100 (record everything) so a new environment is easy
// to verify; dial this down via REACT_APP_MIX_PANEL_SESSION_REPLAY_PERCENT
// once replay volume/coverage has been validated for that environment.
// https://docs.mixpanel.com/docs/tracking-methods/sdks/javascript/javascript-replay
const rawSessionReplayPercent = process.env.REACT_APP_MIX_PANEL_SESSION_REPLAY_PERCENT
const SESSION_REPLAY_PERCENT = rawSessionReplayPercent ? Number(rawSessionReplayPercent) : 100

if (MIXPANEL_ENABLED) {
  mixpanel.init(MIX_PANEL_TOKEN, {
    debug: true,
    persistence: 'localStorage',
    record_sessions_percent: SESSION_REPLAY_PERCENT
  })
}

const actions = {
  identify: (id) => {
    if (MIXPANEL_ENABLED) mixpanel.identify(id)
  },
  alias: (id) => {
    if (MIXPANEL_ENABLED) mixpanel.alias(id)
  },
  track: (name, props) => {
    if (MIXPANEL_ENABLED) mixpanel.track(name, props)
  },
  people: {
    set: (props) => {
      if (MIXPANEL_ENABLED) mixpanel.people.set(props)
    }
  },
  reset: () => {
    if (MIXPANEL_ENABLED) mixpanel.reset()
  },
  // Manual Session Replay controls, for cases where the sampling decision
  // above isn't enough - e.g. forcing capture on for a specific cohort, or
  // pausing around a screen that shouldn't be recorded at all.
  // https://docs.mixpanel.com/docs/tracking-methods/sdks/javascript/javascript-replay#manual-capture
  startSessionRecording: () => {
    if (MIXPANEL_ENABLED) mixpanel.start_session_recording()
  },
  stopSessionRecording: () => {
    if (MIXPANEL_ENABLED) mixpanel.stop_session_recording()
  },
  pauseSessionRecording: () => {
    if (MIXPANEL_ENABLED) mixpanel.pause_session_recording()
  },
  resumeSessionRecording: () => {
    if (MIXPANEL_ENABLED) mixpanel.resume_session_recording()
  },
  getSessionRecordingProperties: () => (MIXPANEL_ENABLED ? mixpanel.get_session_recording_properties() : {}),
  getSessionReplayUrl: () => (MIXPANEL_ENABLED ? mixpanel.get_session_replay_url() : null)
}

export const Mixpanel = actions
